














































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { shipCompany, deleteShip, getShipCompanyName } from '@/api/shipment';
import { emptyRule, rangeLengthRule } from '@/utils/rules';
import moment from 'moment';
import { AppStore } from '@/store/modules/app';

@Component({})
export default class ShipInfoManagerList extends Vue {
  /**自行发货时间选择器 */
  menu: boolean = false;
  /**自行发货的时间 */
  // date: string = new Date().toISOString().substr(0, 10);
  /**物流公司 */
  shipItems: any[] = [...shipCompany];
  /**自行发货信息 */
  @Prop({
    default: () => {
      return [];
    }
  })
  selfLogistics!: any[];
  /**顺丰发货信息 */
  @Prop({
    default: () => {
      return [];
    }
  })
  sfLogistics!: any[];

  /**快递单号rule */
  get shipNumberRules() {
    return [];
    // return [rangeLengthRule(5, 25, '快递单号')];
  }

  /**物流公司rule */
  get shipCompanyRules() {
    return [];
    // return [emptyRule('物流公司')];
  }

  formatDateTimeMM(date: any) {
    return moment(date).format('YYYY-MM-DD');
  }

  /**物流单号输入事件 */
  onLogisticNumber(event: any, item: any) {
    if (event) {
      // 只能输入数字
      // let t = event.replace(/\D/g, '');
      //只能输入数字和英文
      let t = event.replace(/[\W]/g, '');
      this.$nextTick(() => {
        item.number = t;
      });
    }
  }

  /**查看面单 */
  handleViewOrder(item: any) {
    let routeData = this.$router.resolve({
      name: item.company == 'shunfeng' ? 'shufengPrint' : 'zhongtongPrint',
      query: { key: `${item.number}`, isView: 'true' }
    });
    window.open(routeData.href, '_blank');
  }

  /**删除自行发货 j是对应发货item的索引 index是对应发货item的第几条物流，item是对应的物流item*/
  handleSelfShipInfoRemove(j: any, index: any, item: any) {
    //判断是否是正要删除最后一条发货记录
    if (this.selfLogistics.length == 1 && this.selfLogistics[j] && this.selfLogistics[j].items && this.selfLogistics[j].items.length == 1 && this.sfLogistics.length == 0) {
      this.$emit('cancleShip');
    } else {
      if (this.selfLogistics[j] && this.selfLogistics[j].items && this.selfLogistics[j].items.length > 0) {
        deleteShip(item.id)
          .then(response => {
            AppStore.ShowSuccess('删除单号成功');
            //从界面上删除
            this.selfLogistics[j].items.splice(index, 1);
            if (this.selfLogistics[j].items.length <= 0) {
              this.selfLogistics.splice(j, 1);
            }
          })
          .catch(error => {});
      }
    }
  }

  /**取消寄件 */
  handleOtherShipInfoRemove(index: any, item: any) {
    //判断是否是正要删除最后一条发货记录
    if (this.selfLogistics.length == 0 && this.sfLogistics.length == 1) {
      this.$emit('cancleShip');
    } else {
      deleteShip(item.id)
        .then(response => {
          AppStore.ShowSuccess('取消寄件成功');
          //从界面上删除
          this.sfLogistics.splice(index, 1);
        })
        .catch(error => {});
    }
  }

  getLogisticsCompanyName(name: any) {
    return getShipCompanyName(name);
  }
}
